import { Box } from "@mui/material";
import MobileAppHeroSection from "./MobileAppHeroSection";
import MobileAppCardsSection from "./MobileAppCardsSection";
const MobileApp=()=>{
    return(
        <>
        <Box>
<MobileAppHeroSection/>
<Box>
<MobileAppCardsSection/>
</Box>
        </Box>
        </>
    )
}
export default MobileApp